import { render, staticRenderFns } from "./loginVerification.vue?vue&type=template&id=e6cbf50a&"
import script from "./loginVerification.vue?vue&type=script&lang=js&"
export * from "./loginVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports